// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1522":"189fabea9cb8a914","7734":"359d25bbdca4cd0b"}[chunkId] + ".js";
};